<template>
  <div>
    <h5>Job add</h5>

    <ul>
      <li>
        소속회사:
        <el-select v-model="newTeam.company"
                   size="mini"
                   placeholder="회사 선택">
          <el-option v-for="(company, companyId) in companies"
                     :key="companyId"
                     :label="company.name"
                     :value="company.id">
          </el-option>
        </el-select>
      </li>
      <li v-if="newTeam.company === 'sundaytoz'">
        소속그룹:
        <el-select v-model="newTeam.group"
                   size="mini"
                   placeholder="회사 선택">
          <el-option v-for="(groups, groupsId) in groups"
                     :key="groupsId"
                     :label="groups.name"
                     :value="groupsId">
          </el-option>
        </el-select>
      </li>
      <li>
        팀이름:
        <el-input size="mini"
                  placeholder="Please Input"
                  style="width: 200px"
                  v-model="newTeam.name"></el-input>
      </li>
      <li>
        팀에서 사용 할 서비스:
        <el-select v-model="newTeam.available_services"
                   size="mini"
                   multiple
                   filterable
                   allow-create
                   default-first-option
                   placeholder="서비스 선택">
          <el-option v-for="(service, serviceId) in newTeam.permissions"
                     v-if=" serviceId"
                     :key="serviceId"
                     :label="serviceId"
                     :value="serviceId">
          </el-option>
        </el-select>
      </li>
      <li>
        팀 소속 파트:
        <!--<el-select v-model="newTeam.part.job"-->
                   <!--size="mini"-->
                   <!--multiple-->
                   <!--filterable-->
                   <!--allow-create-->
                   <!--default-first-option-->
                   <!--placeholder="직업 관련 파트 선택">-->
          <!--<el-option v-for="item in getPartsListByJob()"-->
                     <!--:key="item"-->
                     <!--:label="item"-->
                     <!--:value="item">-->
          <!--</el-option>-->
        <!--</el-select>-->

        <!--<el-select v-model="newTeam.part.range"-->
                   <!--size="mini"-->
                   <!--multiple-->
                   <!--filterable-->
                   <!--allow-create-->
                   <!--default-first-option-->
                   <!--placeholder="범위 관련 파트 선택">-->
          <!--<el-option v-for="item in getPartsListByRange(newTeam)"-->
                     <!--:key="item"-->
                     <!--:label="item"-->
                     <!--:value="item">-->
          <!--</el-option>-->
        <!--</el-select>-->

        <el-select v-model="newTeam.part.custom"
                   size="mini"
                   multiple
                   filterable
                   allow-create
                   default-first-option
                   placeholder="팀에 맞는 내용을 넣으세요.">
          <el-option v-for="item in newTeam.part.custom"
                     :key="item"
                     :label="item"
                     :value="item">
          </el-option>
        </el-select>
      </li>

      <li>
        설명:
        <el-input size="mini"
                  placeholder="Please Input"
                  style="width: 200px"
                  v-model="newTeam.explain"></el-input>
      </li>
      <!--<li>-->
        <!--도메인별 담당자 지정:-->
        <!--<el-switch v-model="newTeam.is_division"></el-switch>-->
      <!--</li>-->
    </ul>

    <div>
      <el-button @click="handleCreateTeam"
                 size="mini"
                 type="warning">팀 추가 하기</el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import filterTeamView from '@/filters/getTeamViewData';
import filterJobView from '@/filters/getJobViewData';

export default {
  props: {

  },
  filters: {
    filterTeamView,
    filterJobView,
  },
  components: {

  },
  computed: {
    ...mapGetters([
      'companies',
      'services',
      'jobs',
      'teams',
    ]),
  },
  watch: {
    services() {
      Object.keys(this.services).forEach((serviceId) => {
        this.newTeam.permissions[serviceId] = [];
      });
    },
  },
  methods: {
    // getPartsListByJob() {
    //   return filterJobView.getPartsListByJob(this.jobs);
    // },

    getPartsListByRange(currentTeam) {
      return filterTeamView.getPartsListByRange(this.services, currentTeam);
    },

    handleCreateTeam() {
      this.newTeam.permissions = {};
      Object.keys(this.services).forEach((serviceId) => {
        this.newTeam.permissions[serviceId] = [];
      });

      this.newTeam.part.range.forEach((part) => {
        const tag = `tag:${part}`;

        Object.keys(this.newTeam.permissions).forEach((serviceId) => {
          if (this.newTeam.available_services.includes(serviceId)) {
            this.newTeam.permissions[serviceId].push(tag);
          }
        });
      });
      this.$store.dispatch('SUBMIT_TEAM_CREATE_DATA', this.newTeam);
    },
  },
  data() {
    return {
      name: 'CreateTeam',
      newTeam: {
        company: '',
        group: '',
        name: '',
        explain: '',
        part: {
          job: [],
          range: [],
          custom: [],
        },
        available_services: [],
        is_division: false,
        permissions: {},
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/CreateTeam.vue